import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useToast from '@hooks/ui/useToast';
import { CartStatus } from '@models/cart';
import { useFlow } from '@router/stackflow';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';

function CartFooter() {
  const toast = useToast();
  const { push } = useFlow();
  const { orderLines, totalAmount } = useCalculatedCart();
  const soldOutList = orderLines
    .filter((item) => item.status !== CartStatus.ON_SALE);
  const isEmpty = orderLines.length === 0;
  const isAllSoldOuted = soldOutList.length === orderLines.length && !isEmpty;
  const handleOrder = () => {
    if (isAllSoldOuted) {
      toast.error('모든 상품이 품절되었습니다.');
      return;
    }
    if (soldOutList.length !== 0) {
      toast.info('품절, 판매 종료 상품을 제외하고 주문합니다.');
    }
    push('OrderActivity', { path: 'cart' });
  };
  return (
        <Column spacing={16} fullWidth>
            <Column spacing={8} fullWidth>
                <Row justify='space-between' fullWidth>
                    <Text size='lg' color={colors.gray6} fontWeight='bold'>
                        상품 금액
                    </Text>
                    <Text size='lg'>{totalAmount.toLocaleString()}원</Text>
                </Row>
                <Row justify='space-between' fullWidth>
                    <Text size='xl' fontWeight='bold'>
                        결제금액
                    </Text>
                    <Text size='3xl' fontWeight='bold' color={colors.red}>
                        {totalAmount.toLocaleString()}원
                    </Text>
                </Row>
            </Column>
            <Button fullWidth onClick={handleOrder}
                    disabled={isAllSoldOuted || isEmpty} >
                {isAllSoldOuted ? '품절' : '주문하기'}
            </Button>
        </Column>
  );
}

export default CartFooter;
